import { FC } from "react";
import { useTranslation } from "react-i18next";
import CurrencyIconSVG from "../../resources/svg/CurrencyIconSVG";
import ClockIconSVG from "../../resources/svg/ClockIconSVG";
import TelephoneIconSVG from "../../resources/svg/TelephoneIconSVG";
import WashingHandIconSVG from "../../resources/svg/WashingHandIconSVG";
import HandshakeIconSVG from "../../resources/svg/HandshakeIconSVG";
import AccomplishedIconSVG from "../../resources/svg/AccomplishedIconSVG";
import { Link } from "react-router-dom";
import useScreenSize from "../../../custom-hooks/base-hooks/useScreenSize";
import ScrollToTopArrowSVG from "../../resources/svg/functional/ScrollToTopArrowSVG";
import languageServiceFactory from "../../../services/LanguageServiceImpl";

const languageService = languageServiceFactory();

const HeroSection: FC = () => {
    const { t } = useTranslation();
    const { upTo800 } = useScreenSize();

    return (
        <div className="relative mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px] mb-[80px] tmin5:mt-[220px]">
            <div className="relative flex flex-col items-center justify-center w-full ti7:h-[calc(100vh-160px)] tmax4:h-[calc(100vh-152px)]">
                <div className="relative">
                    <h1 className="H48B td4:H32B tmax4:H20B tmax4:text-[21px] text-textWhite text-center">
                        {t("main.title")}
                    </h1>
                    <div className="absolute left-[-30px] top-[-25px] ti7:top-[-20px] tmax4:left-[20px] tmax4:top-[-35px] rotate-[10deg] tmax4:rotate-[-20.2deg] -z-10 H16 flex justify-center items-center dmax2:H14 text-textWhite bg-primaryBlue rounded-[30px] w-fit tmax5:h-[30px] px-4 dmax2:px-2.5 py-2 dmax2:py-[7px]">
                        <CurrencyIconSVG className="w-6 dmax2:w-4 h-6 dmax2:h4 mr-3 dmax2:mr-1.5 text-textWhite" />
                        <span>{t("main.showOffLabel1")}</span>
                    </div>
                    <div
                        className={`absolute ${
                            languageService.isEnglish
                                ? "right-[-30px] di6:right-[-20px] ti6:right-[-40px] ti7:right-[-30px] tmax4:right-[-7px] top-[45px] di6:top-[25px] ti6:top-[25px] ti7:top-[30px] tmax4:top-[48px]"
                                : "right-[35px] di6:right-[-20px] ti6:right-[-60px] ti7:right-[-30px] tmax4:right-[-7px] top-[90px] di6:top-[55px] ti6:top-[65px] ti7:top-[70px] tmax4:top-[72px]"
                        } rotate-[-24deg] tmax4:rotate-[13deg] z-20 H16 flex justify-center items-center dmax2:H14 text-textWhite bg-primaryBlue rounded-[30px] w-fit tmax5:h-[30px] px-4 dmax2:px-2.5 py-2 dmax2:py-[7px]`}
                    >
                        <ClockIconSVG className="w-6 dmax2:w-4 h-6 dmax2:h4 mr-3 dmax2:mr-1.5 text-textWhite" />
                        <span>{t("main.showOffLabel2")}</span>
                    </div>
                    {upTo800 && (
                        <a
                            href="#prosSection"
                            className="absolute right-0 left-0 mx-auto top-[45vh] flex items-center justify-center w-[50px] h-[50px] bg-backgroundButton rounded-full"
                        >
                            <ScrollToTopArrowSVG className="text-textFaded rotate-180" />
                        </a>
                    )}
                </div>
                <p className="H24 td4:H20 tmax4:H16 text-textFaded text-center w-[723px] di6:w-[570px] ti6:w-[570px] ti7:w-[570px] tmax4:w-[302px] mt-6 dmax2:mt-4">
                    {t("main.projectDescription")}
                </p>
                <Link
                    to="/catalog"
                    className="button H16B dmax2:H14B bg-textWarning hover:bg-textWarningFocused h-[50px] dmax2:h-10 px-6 transition duration-300 mt-9 dmax2:mt-8"
                >
                    {t("main.heroSectionButton")}
                </Link>
            </div>
            <div
                id="prosSection"
                className="flex dmax5:flex-wrap justify-center items-center gap-5 td4:gap-3 tmax4:gap-2 w-full mt-[100px] tmax5:mt-[72px]"
            >
                <div className="flex flex-col items-center justify-center bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] transition duration-300 w-[305px] ti6:w-[315px] ti7:w-[270px] tmax4:w-[176px] h-[185px] ti7:h-[175px] tmax4:h-[160px] rounded-[10px]">
                    <TelephoneIconSVG className="w-[64px] dmax2:w-12 h-[64px] dmax2:h-12 text-textWhite mb-5 dmax2:mb-3" />
                    <p className="H16 dmax2:H14 text-textFaded w-[241px] dmax2:w-[112px] text-center">
                        {t("main.prosCardText1")}
                    </p>
                </div>
                <div className="flex flex-col items-center justify-center bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] transition duration-300 w-[305px] ti6:w-[315px] ti7:w-[270px] tmax4:w-[176px] h-[185px] ti7:h-[175px] tmax4:h-[160px] rounded-[10px]">
                    <WashingHandIconSVG className="w-[64px] dmax2:w-12 h-[64px] dmax2:h-12 text-textWhite mb-5 dmax2:mb-3" />
                    <p className="H16 dmax2:H14 text-textFaded w-[241px] dmax2:w-[112px] text-center">
                        {t("main.prosCardText2")}
                    </p>
                </div>
                <div className="flex flex-col items-center justify-center bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] transition duration-300 w-[305px] ti6:w-[315px] ti7:w-[270px] tmax4:w-[176px] h-[185px] ti7:h-[175px] tmax4:h-[160px] rounded-[10px]">
                    <HandshakeIconSVG className="w-[64px] dmax2:w-12 h-[64px] dmax2:h-12 text-textWhite mb-5 dmax2:mb-3" />
                    <p className="H16 dmax2:H14 text-textFaded w-[241px] dmax2:w-[112px] text-center">
                        {t("main.prosCardText3")}
                    </p>
                </div>
                <div className="flex flex-col items-center justify-center bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] transition duration-300 w-[305px] ti6:w-[315px] ti7:w-[270px] tmax4:w-[176px] h-[185px] ti7:h-[175px] tmax4:h-[160px] rounded-[10px]">
                    <AccomplishedIconSVG className="w-[64px] dmax2:w-12 h-[64px] dmax2:h-12 text-textWhite mb-5 dmax2:mb-3" />
                    <p className="H16 dmax2:H14 text-textFaded w-[241px] dmax2:w-[112px] text-center">
                        {t("main.prosCardText4")}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
